module.exports = __webpack_public_path__ + "img/w-cutBagB03.69cfca47.jpg";